import * as paymentLocations from 'constants/enums/paymentLocations'

export default {
  [paymentLocations.PROJECT_ACCOUNT]: 'Projektový účet',
  [paymentLocations.BANK_SECURITY_ACCOUNT]: 'Jistotní účet u banky',
  [paymentLocations.SAFEKEEPING]: 'Úschova',
} as const
